import {
//    ROOM_LIST_HD_URL,
    ROOM_LIST_NEO_URL,
    PERSONAL_ROOM_LIST_URL,
    REAL_GIFT_LIST_URL,
    LAST_WALL_MATERIALS_URL,
    LAST_BOBSTORE_SUBMISSIONS_URL,
    LAST_FILMS_AMATEURS_URL,
    LAST_VIRTUAL_GIFTS_URL,
    MESSAGE_OF_DAY_URL,
    FAVOURITES_URL,
    GENEROUS_USERS_URL
} from './constants';

import { getAxios } from './axios';

/*
 *export function getRoomsHd() {
 *    let axios = getAxios();
 *
 *    return axios.get(ROOM_LIST_HD_URL);
 *}
 */

export function getRoomsNeo() {
    let axios = getAxios();
    
    return axios.get(ROOM_LIST_NEO_URL);
}

export function getPersonalRooms() {
    let axios = getAxios();

    return axios.request({
        url: PERSONAL_ROOM_LIST_URL,
        method: 'get'
    });
}

export function getRealGiftsIndex(limit) {
    let axios = getAxios();

    return axios.get(REAL_GIFT_LIST_URL, {
        params: {real_gift_limit: limit}
    });
}

export function getLastWallMaterialsIndex(limit, options) {
    let axios = getAxios();
    let params = {wall_materials_limit: limit};
    if (options && options.kind) {
        params.kind = options.kind;
    } else {
        params.kind = 'wall';
    }

    return axios.get(LAST_WALL_MATERIALS_URL, {
        params: params
    });
}

export function getLastBobstoreWardrobeIndex(limit) {
    return getLastWallMaterialsIndex(limit, {kind: 'wardrobe'})
}

export function getLastBobstoreSubmissionsIndex(limit) {
    let axios = getAxios();

    return axios.get(LAST_BOBSTORE_SUBMISSIONS_URL, {
        params: {bobstore_submission_limit: limit}
    });
}

export function getLastFilmsAmateursIndex(limit) {
    let axios = getAxios();

    return axios.get(LAST_FILMS_AMATEURS_URL, {
        params: {amateur_films_limit: limit}
    });
}

export function getLastVirtualGiftsIndex(limit) {
    let axios = getAxios();

    return axios.get(LAST_VIRTUAL_GIFTS_URL, {
        params: {virtual_gift_limit: limit}
    });
}

export function getMessageOfDay(id=null) {
    let axios = getAxios();

    return axios.get(MESSAGE_OF_DAY_URL, {
        params: {id: id}
    });
}

export function getFavouritesIndex(page, limit) {
    let axios = getAxios();

    return axios.get(FAVOURITES_URL, {
        params: {page, limit}
    });
}

export function getGenerousUsersIndex(page, limit) {
    let axios = getAxios();

    return axios.get(GENEROUS_USERS_URL, {
        params: {page, limit}
    });
}



// WEBPACK FOOTER //
// ./src/backend-helpers/main.js